import React from "react";
import { VStack } from "@chakra-ui/react";
import { Vitals, Comments } from "./components";

const PostAnesthesia: React.FC = () => (
  <VStack spacing={6} alignItems="left">
    <Vitals />
    <Comments />
  </VStack>
);

export default PostAnesthesia;
